import { SidebarMode, StateUI } from '@/store/state';

export const isDependencyGraphOpen = (state: StateUI): boolean => state.isDependencyGraphOpen;
export const getSidebarMode = (state: StateUI): SidebarMode => state.sidebarMode;
